import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";

const PlanIcon = {
  name: 'PlanIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function (s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function (h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' 
      ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em'
      : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        "stroke-width": "0px"
      },
      "class": "feather feather-plan"
    }, ctx.data]), [
      h("g", {
        attrs: {
          opacity: "0.7"
        }
      }, [
        h("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M8.49512 7.00391H19.6372V8.50391H8.49512V7.00391Z",
            fill: "currentColor"
          }
        }),
        h("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M3.25 7.69391C3.25 5.83256 4.76861 4.33252 6.63019 4.33252C8.49178 4.33252 10.0104 5.83256 10.0104 7.69391C10.0104 9.55526 8.49178 11.0553 6.63019 11.0553C4.76861 11.0553 3.25 9.55526 3.25 7.69391ZM6.63019 5.83252C5.58687 5.83252 4.75 6.67112 4.75 7.69391C4.75 8.71671 5.58687 9.55531 6.63019 9.55531C7.67351 9.55531 8.51039 8.71671 8.51039 7.69391C8.51039 6.67112 7.67351 5.83252 6.63019 5.83252Z",
            fill: "currentColor"
          }
        }),
        h("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M15.5049 16.6167H4.36285V18.1167H15.5049V16.6167Z",
            fill: "currentColor"
          }
        }),
        h("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M20.75 17.3062C20.75 15.4449 19.2314 13.9448 17.3698 13.9448C15.5082 13.9448 13.9896 15.4449 13.9896 17.3062C13.9896 19.1676 15.5082 20.6676 17.3698 20.6676C19.2314 20.6676 20.75 19.1676 20.75 17.3062ZM17.3698 15.4448C18.4131 15.4448 19.25 16.2834 19.25 17.3062C19.25 18.329 18.4131 19.1676 17.3698 19.1676C16.3265 19.1676 15.4896 18.329 15.4896 17.3062C15.4896 16.2834 16.3265 15.4448 17.3698 15.4448Z",
            fill: "currentColor"
          }
        })
      ])
    ]);
  }
};

export default PlanIcon; 